import { useMemo } from 'react';

import { mapWorkflowAttributesToAttributes } from '@atom/utilities/assetDraftUtilities';

import ChatAssetDraftAttributes from './ChatAssetDraftAttributes';
import { useChatAssetDraftContext } from './ChatAssetDraftContext';

const ChatAssetDraftRootAttributes = () => {
  const { schema, draftAsset, disabled, errorsByPath, handleAttributeChange } =
    useChatAssetDraftContext();

  const attributes = useMemo(
    () => mapWorkflowAttributesToAttributes(draftAsset?.attributes ?? {}),
    [draftAsset?.attributes],
  );

  if (!schema || !draftAsset) {
    return null;
  }

  return (
    <ChatAssetDraftAttributes
      schema={schema}
      workflowAttributes={draftAsset.attributes}
      attributes={attributes}
      onAttributeChange={(id, value) => handleAttributeChange([], id, value)}
      errorAttributeIds={errorsByPath.get('') ?? new Set()}
      disabled={disabled}
    />
  );
};

export default ChatAssetDraftRootAttributes;
